import { render, staticRenderFns } from "./ops_desk.vue?vue&type=template&id=2590a0e4&scoped=true&"
import script from "./ops_desk.vue?vue&type=script&lang=js&"
export * from "./ops_desk.vue?vue&type=script&lang=js&"
import style0 from "./ops_desk.vue?vue&type=style&index=0&id=2590a0e4&scoped=true&lang=css&"
import style1 from "./ops_desk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590a0e4",
  null
  
)

export default component.exports